import React from 'react'
import './Settings.scss'

const Settings = () => {
    return (
        <div className='Settings'>
            Settings
        </div>
    )
}

export default Settings
